import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link';
import Immutable from 'immutable';

import { getCurrentUser } from 'selectors/session';

import {
  buildTeamAppTeamCalendlyUrl,
  buildUtmParams,
  calendlyUrlBuilderCommand,
  UtmCampaignType,
  UtmContentType,
} from 'features/calendlyEnterprise';

import { toI18n } from 'util/i18n';
import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUx } from 'util/uxEvents';

export type CalendlyLinkProps = {
  url?: string;
  onClickLink: () => void;
  linkPrefixCopy?: string;
  utmContent?: UtmContentType;
  utmCampaign?: UtmCampaignType;
  currentUser?: Immutable.Map<string, string>;
};

const CalendlyLink = ({
  url,
  utmContent,
  utmCampaign,
  onClickLink,
  currentUser,
  linkPrefixCopy = 'monetization.click_to_call.schedule_a_call.text',
}: CalendlyLinkProps) => {
  const buttonText = toI18n('monetization.click_to_call.schedule_a_call.link');
  const calendlyUrl = buildTeamAppTeamCalendlyUrl(
    calendlyUrlBuilderCommand({
      currentUser,
      queryParams: utmContent
        ? buildUtmParams(utmContent, utmCampaign || null)
        : {},
    })
  );

  const trackUx = useTrackUx({
    link_url: url || calendlyUrl,
    button_text: buttonText,
    element: 'schedule_call',
  } as never);

  const handleClickLink = useCallback(() => {
    trackUx(EVENT_ACTIONS.LINK_CLICKED, TRACK_ACTION_TYPES.CLICK);
    onClickLink();
  }, [onClickLink, trackUx]);

  return (
    <Box mb={24}>
      <Text variant="body">
        {toI18n(linkPrefixCopy)}{' '}
        <Link onClick={handleClickLink}>{buttonText}</Link>
      </Text>
    </Box>
  );
};

export default connect(state => ({
  currentUser: getCurrentUser(state),
}))(CalendlyLink);
